var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
import { formatNavParams } from './nav';
import { FormContext } from './form/form-context';
// xbpm events
export var SCREENFLOW_END = Symbol('SCREENFLOW_END');
export var FORM_DESTROYED = Symbol('FORM_DESTROYED');
export var SCROLL_TO_ERROR = Symbol('SCROLL_TO_ERROR');
export var NOT_AUTHORIZED = Symbol('NOT_AUTHORIZED');
var LAST_NAV_PARAMS = 'xbpm:last_nav_params';
var context;
var XbpmContext = /** @class */ (function () {
    function XbpmContext(apiService, authService, navService, logger, storage, reduxStore) {
        var _this = this;
        this.apiService = apiService;
        this.authService = authService;
        this.navService = navService;
        this.logger = logger;
        this.storage = storage;
        this.reduxStore = reduxStore;
        this.providers = new Map();
        this.eventListeners = new Map();
        this.getLastNavigationParams = function () { return __awaiter(_this, void 0, void 0, function () {
            var _a, _b;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        _a = this;
                        _b = this.navigationParams;
                        if (_b) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.storage.getItem(LAST_NAV_PARAMS)];
                    case 1:
                        _b = (_c.sent());
                        _c.label = 2;
                    case 2: return [2 /*return*/, (_a.navigationParams = _b)];
                }
            });
        }); };
        this.storeNavigationParams = function (params) {
            // костыль чтобы после релогина не открывалась в top окне таска из процесса из айфрейма
            if (!_this.isRoot() && _this.isOnSameHost()) {
                return;
            }
            if (!params) {
                _this.storage.removeItem(LAST_NAV_PARAMS);
            }
            else {
                _this.storage.setItem(LAST_NAV_PARAMS, formatNavParams(params));
            }
            _this.navigationParams = params;
        };
        this.setProvider = function (name, provider) { return _this.providers.set(name, provider); };
        this.getProvider = function (name) { return _this.providers.get(name); };
        // xbpm context events
        this.emit = function (type, data) {
            if (_this.eventListeners.get(type)) {
                _this.eventListeners.get(type).forEach(function (l) { return l(data); });
            }
        };
        this.on = function (type, listener) {
            if (!_this.eventListeners.get(type)) {
                _this.eventListeners.set(type, new Set());
            }
            _this.eventListeners.get(type).add(listener);
            return {
                remove: function () { return _this.eventListeners.get(type).delete(listener); },
            };
        };
        this.off = function (type, listener) {
            if (_this.eventListeners.get(type)) {
                _this.eventListeners.get(type).delete(listener);
            }
        };
    }
    Object.defineProperty(XbpmContext.prototype, "formContext", {
        get: function () {
            return FormContext.getCurrent();
        },
        enumerable: true,
        configurable: true
    });
    XbpmContext.prototype.isRoot = function () {
        var isRootWindow = false;
        try {
            isRootWindow = window === window.parent || window.hasOwnProperty('Cypress');
        }
        catch (e) {
            console.warn('Access denied to root window');
        }
        return isRootWindow;
    };
    XbpmContext.prototype.isOnSameHost = function () {
        var isWindowOnSameHost = false;
        try {
            isWindowOnSameHost = window.location.host === window.parent.location.host;
        }
        catch (e) {
            console.warn('Access denied to root window');
        }
        return isWindowOnSameHost;
    };
    XbpmContext.createContext = function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        return (context = new (XbpmContext.bind.apply(XbpmContext, __spreadArrays([void 0], args)))());
    };
    XbpmContext.getContext = function () { return context; };
    return XbpmContext;
}());
export { XbpmContext };
//# sourceMappingURL=context.js.map